/* eslint-disable */
import React from 'react';
import { ChevronDown, ChevronUp, Building, Users, Target, Database } from 'lucide-react';

const LeadershipStructure = () => {
  const [expandedUnit, setExpandedUnit] = React.useState(null);

  const organizationalHierarchy = {
    director: {
      name: "Director",
      title: "Department of Health Security, Surge Capacity Development & One Health",
      description: "Provides overall strategic leadership, direction, and oversight for all departmental activities and units.",
      level: 1
    },
    units: [
      {
        id: "operations",
        title: "Operations, Administration & Support Services Unit",
        icon: <Building className="unit-icon" />,
        head: "Unit Head",
        color: "#3B82F6",
        responsibilities: [
          "Finance, HR, logistics and administrative management",
          "Rapid response team development and maintenance",
          "Training programs and simulation exercises",
          "Capacity-building initiatives"
        ],
        subUnits: [
          "Administration Division",
          "Rapid Response Team Coordination",
          "Training & Capacity Building"
        ]
      },
      {
        id: "surveillance",
        title: "Disease Surveillance Unit",
        icon: <Target className="unit-icon" />,
        head: "Unit Head",
        color: "#10B981",
        responsibilities: [
          "Integrated human-animal-environment health monitoring",
          "Multisectoral collaboration facilitation",
          "Outbreak investigation and response coordination",
          "Epidemiological data analysis"
        ],
        subUnits: [
          "Human Health Surveillance",
          "Animal Health Surveillance",
          "Environmental Health Monitoring"
        ]
      },
      {
        id: "planning",
        title: "Planning, Research, Monitoring & Evaluation Unit",
        icon: <Users className="unit-icon" />,
        head: "Unit Head",
        color: "#8B5CF6",
        responsibilities: [
          "Performance tracking and data analysis",
          "Operational research coordination",
          "Evidence-based policy development support",
          "Strategic planning and reporting"
        ],
        subUnits: [
          "Research & Development",
          "Monitoring & Evaluation",
          "Strategic Planning"
        ]
      },
      {
        id: "ict",
        title: "ICT and Data Management Unit",
        icon: <Database className="unit-icon" />,
        head: "Unit Head",
        color: "#F59E0B",
        responsibilities: [
          "IT infrastructure management and maintenance",
          "System software and security updates",
          "Technology recommendations and implementation",
          "Data management and representation"
        ],
        subUnits: [
          "IT Infrastructure",
          "Data Systems",
          "Technology Implementation"
        ]
      }
    ]
  };

  const toggleUnit = (unitId) => {
    setExpandedUnit(expandedUnit === unitId ? null : unitId);
  };

  return (
    <section className="leadership-section" id='leadership'>
      <div className="section-header">
        <div className="section-badge">Organization</div>
        <h2>Leadership & Structure</h2>
        <p className="section-description">
          Our hierarchical structure ensures efficient coordination and specialized expertise across all functions
        </p>
      </div>

      <div className="org-chart-container">
        <div className="org-chart">
          <div className="org-level director-level">
            <div className="position-card director">
              <div className="position-header">
                <div className="position-icon">D</div>
                <div className="position-info">
                  <h3>{organizationalHierarchy.director.name}</h3>
                  <p className="position-title">{organizationalHierarchy.director.title}</p>
                </div>
              </div>
              <p className="position-description">{organizationalHierarchy.director.description}</p>
            </div>
          </div>

          <div className="connection-line"></div>

          <div className="org-level units-level">
            <div className="units-grid">
              {organizationalHierarchy.units.map((unit) => (
                <div key={unit.id} className="org-unit">
                  <div className="connecting-line-up"></div>
                  <div 
                    className={`unit-card ${expandedUnit === unit.id ? 'expanded' : ''}`}
                    onClick={() => toggleUnit(unit.id)}
                  >
                    <div className="unit-header">
                      <div className="unit-icon-container" style={{ backgroundColor: unit.color }}>
                        {unit.icon}
                      </div>
                      <div className="unit-info">
                        <h4>{unit.title}</h4>
                        <p className="unit-head">{unit.head}</p>
                      </div>
                      <div className="expand-icon">
                        {expandedUnit === unit.id ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                      </div>
                    </div>

                    {expandedUnit === unit.id && (
                      <div className="unit-details">
                        <div className="responsibilities-section">
                          <h5>Key Responsibilities</h5>
                          <ul className="responsibilities-list">
                            {unit.responsibilities.map((resp, idx) => (
                              <li key={idx}>{resp}</li>
                            ))}
                          </ul>
                        </div>
                        
                        <div className="subunits-section">
                          <h5>Functional Divisions</h5>
                          <div className="subunits-list">
                            {unit.subUnits.map((subUnit, idx) => (
                              <div key={idx} className="subunit-item">
                                {subUnit}
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="leadership-profiles" id='Executive-leadership'>
        <div className="profiles-header">
          <h3>Executive Leadership</h3>
          <p>Meet the leaders guiding our department's strategic direction</p>
        </div>
        <div className="profiles-grid">
          <div className="profile-card placeholder">
            <div className="profile-avatar">MOCA</div>
            <div className="profile-info">
              <h4>Ministry of Cabinet Affairs</h4>
              <p>Profile coming soon</p>
            </div>
          </div>
          <div className="profile-card placeholder">
            <div className="profile-avatar">MOH</div>
            <div className="profile-info">
              <h4>Ministry of Health</h4>
              <p>Profile coming soon</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeadershipStructure;